import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { CheckCircle, XCircle, TriangleAlert, X } from 'lucide-react';

const AlertMessage = ({
  open,
  onClose,
  status,
  message,
}: {
  open: boolean;
  onClose: (open: boolean) => void;
  status?: 'pending' | 'success' | 'error';
  message?: string;
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent className="w-11/12 max-w-96">
        <AlertDialogHeader className="flex flex-col items-center justify-center">
          <AlertDialogCancel title="Close" asChild>
            <Button
              className="px-2 absolute top-2 right-2"
              variant="ghost"
              size="icon"
            >
              <X size={16} />
            </Button>
          </AlertDialogCancel>
          <AlertDialogTitle className="sr-only">{status}</AlertDialogTitle>
          {status === 'success' ? (
            <CheckCircle size={64} strokeWidth={1.5} className="text-success" />
          ) : status === 'error' ? (
            <XCircle size={64} strokeWidth={1.5} className="text-destructive" />
          ) : (
            <TriangleAlert
              size={64}
              strokeWidth={1.5}
              className="text-warning"
            />
          )}
          <AlertDialogDescription className="text-center">
            {message}
          </AlertDialogDescription>
        </AlertDialogHeader>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default AlertMessage;
